import { render, staticRenderFns } from "./ListFolders.vue?vue&type=template&id=b1874aba&scoped=true&lang=pug&"
import script from "./ListFolders.vue?vue&type=script&lang=js&"
export * from "./ListFolders.vue?vue&type=script&lang=js&"
import style0 from "./ListFolders.vue?vue&type=style&index=0&id=b1874aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1874aba",
  null
  
)

export default component.exports